import React, { useMemo } from 'react'
import "./resultHeader.scss"
import { useSelector } from 'react-redux'
import { SelectNextGameTime, SelectLastWinCard } from '../../../redux/2d-slice/gameInfo2dSlice'
import moment from 'moment'

function ResultHeader() {
    let currentDrawTime = useSelector(SelectNextGameTime)
    let last_win_cards = useSelector(SelectLastWinCard)

    let resultCard = useMemo(() => {
        if (last_win_cards.length) {
            let wincardObj = last_win_cards[2]
            let resultObj = { 1: [], 3: [], 5: [] }
            Object.keys(wincardObj).forEach((objIndex) => {
                Object.keys(wincardObj[objIndex]).forEach((numberIndex) => {
                    resultObj[numberIndex]?.push(wincardObj[objIndex][numberIndex])
                })
            })
            return resultObj
        }
    }, [last_win_cards])

    const getNumberColor = (num) => {
        const str = String(num);
        if (str.length >= 2 && str[str.length - 1] === str[str.length - 2]) {
            return 'red';       // last 2 same
        }
        return '#000';      // blue (या 'black')
    };

    return (
        <>
            <style>{`
                .hover-table {
                    border-collapse: collapse;
                    width: 100%;
                }

                .hover-table th,
                .hover-table td {
                    border: 1px solid #ddd;
                    /*padding: 8px;
                    text-align: left;*/
                }

                .hover-table tr:first-child {
                    display: table-row;
                    /* Show first row by default */
                }

                .hover-table tr:nth-child(n+2) {
                    display: none;
                    /* Hide other rows by default */
                }

                .hover-table:hover tr:first-child {
                    display: none;
                    /* Hide first row on hover */
                }

                .hover-table:hover tr:nth-child(n+2) {
                    display: table-row;
                    /* Show other rows on hover */
                }

                .hover-table:not(:hover) tr:first-child {
                    display: table-row;
                }

                .hover-table:not(:hover) tr:nth-child(n+2) {
                    display: none;
                }

                .hover-table th {
                    /*background-color: #f2f2f2;*/
                }
            `}</style>
            {/* <div className='result_div'> */}
            {/*  */}

            <table width="100%" height="100%" align="left">
                <tbody>
                    <tr>
                        <th width="5%" className='result_head' style={{ backgroundColor: "#a2da17", fontSize: '12px', border: '1px solid #000' }}>
                            Result: {currentDrawTime ? moment(currentDrawTime, 'h:mm A').subtract(30, 'minute').format('hh:mm A') : ''}
                            {/* <span className='preDrawTime'>1:15 PM</span> */}
                            {/* <span className='preDrawTime'></span> */}
                        </th>
                        {/*  */}
                        {resultCard &&
                            <>
                                {resultCard[1]?.map((number) => {
                                    const bgColor = '#a2da17';
                                    const textColor = getNumberColor(number);

                                    return (
                                        <th
                                            width="5%"
                                            key={number}
                                            style={{
                                                backgroundColor: bgColor,
                                                color: textColor,
                                                border: '1px solid #000'
                                            }}
                                            className="san_res_col"
                                        >
                                            {number}
                                        </th>
                                    )
                                })}
                            </>
                        }
                    </tr>
                    <tr>
                        <th width="5%" className='result_head' style={{ backgroundColor: "#01b0f1", fontSize: '12px', border: '1px solid #000' }}>
                            Result: {currentDrawTime ? moment(currentDrawTime, 'h:mm A').subtract(30, 'minute').format('hh:mm A') : ''}
                        </th>
                        {/*  */}
                        {resultCard &&
                            <>
                                {resultCard[3]?.map((number) => {
                                    const bgColor = '#01b0f1';
                                    const textColor = getNumberColor(number);

                                    return (
                                        <th
                                            width="5%"
                                            key={number}
                                            style={{
                                                backgroundColor: bgColor,
                                                color: textColor,
                                                border: '1px solid #000'
                                            }}
                                            className="san_res_col"
                                        >
                                            {number}
                                        </th>
                                    )
                                })}
                            </>
                        }
                    </tr>

                    <tr>
                        <th width="5%" className='result_head' style={{ backgroundColor: "#FFFF00", fontSize: '12px', border: '1px solid #000' }}>
                            Result: {currentDrawTime ? moment(currentDrawTime, 'h:mm A').subtract(30, 'minute').format('hh:mm A') : ''}
                            {/* <span className='preDrawTime'>1:15 PM</span> */}
                            {/* <span className='preDrawTime'></span> */}
                        </th>
                        {/*  */}
                        {resultCard &&
                            <>
                                {resultCard[5]?.map((number) => {
                                    const bgColor = '#FFFF00';
                                    const textColor = getNumberColor(number);

                                    return (
                                        <th
                                            width="5%"
                                            key={number}
                                            style={{
                                                backgroundColor: bgColor,
                                                color: textColor,
                                                border: '1px solid #000'
                                            }}
                                            className="san_res_col"
                                        >
                                            {number}
                                        </th>
                                    )
                                })}
                            </>
                        }
                    </tr>
                </tbody>
            </table>
        </>
    )
}

export default ResultHeader